@if (dataWarning(); as warning) {
	<ion-toolbar [color]="warningColor(warning)">
		<ion-title>
			<div class="ion-display-flex ion-align-items-center">
				<ion-icon size="large" [name]="warningIcon(warning)" />
				<div class="ion-padding-start ion-padding-vertical ion-text-wrap">
					<div class="icds-text-size-md">{{ warning.message }}</div>
					<div
						class="icds-text-size-sm"
						style="margin-top: 8px; text-decoration: underline; cursor: pointer"
						(click)="isMoreInfoModalOpen.set(true)"
					>
						{{ "appSunsetBanner.moreInfoLink" | translate }}
					</div>
				</div>
			</div>
		</ion-title>
	</ion-toolbar>
	<icds-alert-dialog
		[dataHeader]="'appSunsetBanner.moreInfoModal.title' | translate"
		[dataMessage]="'appSunsetBanner.moreInfoModal.messageHTML' | translate"
		[(dataIsOpen)]="isMoreInfoModalOpen"
	/>
}
